import React, { FunctionComponent } from 'react';
import { SanityVideo } from '../../types/common';
import './styles.scss';

type VideoProps = {
  data: SanityVideo;
}

const Video: FunctionComponent<VideoProps> = ({ data }) => {
  if (data.typeVideo === 'Youtube' && data.youtube) {
    const url = data.youtube.split('&')[0].replace('watch?v=', 'embed/');
    return (
      <div className='video'>
        <iframe
          src={url}
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
          id={"youtubeVideo"}
        />
      </div>
    );
  }

  if (data.typeVideo === 'Vimeo' && data.vimeo) {
    const url = data.vimeo.replace('vimeo.com/', 'player.vimeo.com/video/');
    return (
      <div className='video'>
        <iframe
          src={url}
          allow='autoplay; fullscreen; picture-in-picture'
          allowFullScreen
        />
      </div>
    );
  }

  if (!data.upload) {
    return null;
  }

  return (
    <video
      controls
      controlsList='nodownload'
      className='video'
    >
      <source
        src={data.upload.asset.url}
        type={data.upload.asset.mimeType}
      />
    </video>
  );
}

export default Video;
